import React, { useEffect } from "react";

export default function TaggingMemberSystem({
    textareaRef,
    members,
    searchTerm,
}: any) {
    const [focusedMember, setFocusedMember] = React.useState(0);
    const [isTagging, setIsTagging] = React.useState(false);
    const tagMember = (member: any) => {
        if (textareaRef.current) {
            const textarea = textareaRef.current;
            const selectionStart = textarea.selectionStart;
            const lastAt = textarea.value.lastIndexOf("@", selectionStart - 1);
            const before = textarea.value.slice(0, lastAt);
            const after = textarea.value.slice(selectionStart);
            if(!member) return setIsTagging(false);
            textarea.value = `${before}<@${member.id}> ${after}`;
            textarea.focus();
            textarea.selectionStart = textarea.selectionEnd = before.length + member.id.length + 4;
            setIsTagging(false);
        }
    };

    const filteredMembers = React.useMemo(() => {
        if (!searchTerm) return members?.data?.members?.slice(0, 16);
        return members?.data?.members?.filter((member: any) =>
            member.username.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [searchTerm]);
    
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (isTagging) {
                if (e.key === "ArrowDown") {
                    e.preventDefault();
                    setFocusedMember((prev:any) => (prev + 1) % filteredMembers.length);
                } else if (e.key === "ArrowUp") {
                    e.preventDefault();
                    setFocusedMember((prev:any) => (prev - 1 + filteredMembers.length) % filteredMembers.length);
                }
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [isTagging, focusedMember, filteredMembers]);
    

    useEffect(() => {

        const handleKeyDown = (e: KeyboardEvent) => {
            if (isTagging && (e.key === "Enter" || e.key === "Tab")) {
                e.preventDefault();
                tagMember(filteredMembers[focusedMember]);
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [isTagging, focusedMember, filteredMembers]);

    return {
        filteredMembers,
        tagMember,
        isTagging,
        setIsTagging,
        focusedMember,
        setFocusedMember
    }
}